'use strict';
import { tns } from "tiny-slider/src/tiny-slider"

class ReusableContentOurProgrammes {

    constructor($target) {

        //Private properties
        $target;

        let name = "HELLO";

        function init(){
            initSLider();
            addClasses();
            getSliderArray();
        }

        function initSLider(){
            var slider = tns({
                container: $target.find('.reusable-content-our-programmes__content_container')[0],
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls:false,
                nav: true,
                navPosition: "bottom",
                loop: false,
                edgePadding: 20,
                gutter: 20,

                responsive: {
                    768: {
                      items: 6,
                    }
                }
              });
        }

        function addClasses(){
            var tnsOuter = $target.find('.tns-outer');
            var tnsInner = $target.find('.tns-inner');
            var tnsSlider = $target.find('.tns-slider');
            var tnsOvh = $target.find('.tns-ovh');
            var tnsitem = $target.find('.tns-item');

            tnsOuter.addClass('reusable-content-our-programmes__tns-outer');
            tnsInner.addClass('reusable-content-our-programmes__tns-inner');
            tnsSlider.attr('id','tns-slider_our_programmes');
            tnsOvh.attr('id','tns-ovh_our_programmes');
            tnsitem.addClass('reusable-content-our-programmes__tns-item');

            $(tnsitem).css('padding', 'none');

        }



        function getSliderArray(){
            var tnsitem = $target.find('.tns-item');
            var sliderWidth = (tnsitem.length)*100 +"%";
            var tnsSlider = $target.find('#tns-slider_our_programmes');
            
            if($(window).width() <= 767){
                $(tnsSlider).css('width', sliderWidth);
            }else{
                $(tnsSlider).css('width', '100%');
            }
        }

        var windowSize = window.matchMedia("(max-width: 767px)");
        sliderResize(windowSize);
        windowSize.addListener(sliderResize); 

        function sliderResize(windowSize) {

            
            
            if (windowSize.matches) {  
                getSliderArray();
            } else {
                getSliderArray();
            }
        }

        init()
        return {

            //Public properties
            name:name,

            publicBlockHero:function(string){

                // $target.append("HELLO!"+string);
                // console.log(name)
                // console.log(string)
                // console.log($target)

            }

        }

    }

}

export default ReusableContentOurProgrammes;
